import { LoggerCollection } from '@sensenet/client-utils';
import React, { createContext } from 'react';
import { useInjector } from "../hooks/index.js";
/**
 * Context for a Logger instance
 */
export const LoggerContext = /*#__PURE__*/createContext(new LoggerCollection());
LoggerContext.displayName = 'LoggerContext';

/**
 * Wrapper for the LoggerContext component.
 * Returns the current injector's default logger. Has to be wrapped with **InjectorContext**
 */
export const LoggerContextProvider = ({
  children
}) => {
  const injector = useInjector();
  return /*#__PURE__*/React.createElement(LoggerContext.Provider, {
    value: injector.logger
  }, children);
};
//# sourceMappingURL=logger.js.map